module.exports = __webpack_public_path__ + "7d088296/img/trash-icon.ff8201c7.svg";